import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-md full-width" }
const _hoisted_2 = { class: "col-12 col-md-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-h6" }, "プレチェクを始める（無料）", -1)
const _hoisted_4 = { class: "row q-gutter-sm" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col-shrink" }
const _hoisted_7 = { class: "col-12 col-md-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "text-h6" }, "ログイン", -1)
const _hoisted_9 = { class: "column q-gutter-sm" }

import { useStart, useLogin } from '@/composables'

/** 無料で始める */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { startForm, start } = useStart()

/** 有料会員 */
const { loginForm, login } = useLogin()

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(start) && _unref(start)(...args)), ["prevent"]))
      }, [
        _createVNode(_component_q_card, {
          flat: "",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_q_input, {
                      outlined: "",
                      dense: "",
                      type: "email",
                      label: "Email",
                      modelValue: _unref(startForm).email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(startForm).email) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_q_btn, {
                      type: "submit",
                      unelevated: "",
                      color: "primary",
                      label: "プレチェクを始める"
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_unref(login) && _unref(login)(...args)), ["prevent"]))
      }, [
        _createVNode(_component_q_card, {
          flat: "",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_input, {
                      outlined: "",
                      dense: "",
                      type: "email",
                      label: "メールアドレス",
                      modelValue: _unref(loginForm).loginId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(loginForm).loginId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_input, {
                      outlined: "",
                      dense: "",
                      type: "password",
                      label: "パスワード",
                      modelValue: _unref(loginForm).loginPw,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(loginForm).loginPw) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn, {
                      type: "submit",
                      unelevated: "",
                      color: "primary",
                      label: "ログインする"
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 32)
    ])
  ]))
}
}

})